// PamDrawer — drawer flutuante da almoxarife Pam Beesly.
// Wrapper fino sobre HydraDrawer que injeta config visual + agente='pam'.
// Visível apenas no módulo Administrativo.
import HydraDrawer, { type AgenteConfig } from './HydraDrawer';
import IconPam from './IconPam';

const PAM_CONFIG: AgenteConfig = {
  agente: 'pam',
  nome: 'Pam',
  subtitulo: 'Almoxarife virtual · Claude Sonnet 4.5',
  corPrimaria: '#7C3AED',
  gradiente: 'linear-gradient(135deg, #4C1D95 0%, #7C3AED 100%)',
  bubbleGradiente: 'linear-gradient(135deg, #7C3AED 0%, #A78BFA 100%)',
  bubbleSombra: '0 4px 16px rgba(124,58,237,0.35)',
  icone: <IconPam size={28} color="#fff" />,
  iconeHeader: <IconPam size={22} color="#fff" />,
  iconeVazio: <IconPam size={42} />,
  dicaTitulo: 'Oi, sou a Pam!',
  dicaTexto:
    'Cuido do estoque de consumíveis (marcos, EPIs, uniformes).\nPergunte sobre o que tem, o que precisa comprar, ou peça pra registrar uma entrada/saída.',
  exemplos: [
    '"Quanto temos de marco geodésico?"',
    '"O que está abaixo do mínimo?"',
    '"Comprei 50 marcos a R$ 12 cada, registra"',
    '"Quanto consumimos no contrato HY26032?"',
  ],
  placeholder: 'Pergunte sobre estoque, compras, consumo...',
};

export default function PamDrawer() {
  return <HydraDrawer config={PAM_CONFIG} />;
}
